import React from "react";
import { Icon } from "@iconify/react";

const IconifyIcon = ({ icon, width = 20, height = 20, color = "currentColor", className = "" }) => {
  return (
    <Icon
      icon={icon}
      width={width}
      height={height}
      color={color}
      className={className}
    />
  );
};

export default IconifyIcon;
